module.exports = __webpack_public_path__ + "static/media/travel-armenia.32306233.jpg";